import React from 'react';
import styles from './ProfileChecklist.module.scss';
import { useTranslation } from 'react-i18next';
import { FundingProfileData, GroupProfileData } from '@Types';
import classnames from 'classnames';
import { RiCircleFill, RiCheckboxCircleFill } from 'react-icons/ri';

interface ProfileChecklistProps {
  profileData: GroupProfileData | FundingProfileData;
}

export const ProfileChecklist = ({ profileData }: ProfileChecklistProps) => {
  const { t } = useTranslation('dashboard');

  // The breakdown of this logic and why it was chosen this way can be found here:
  // https://www.notion.so/actionfunder/Profile-Completion-Breakdown-a4fa285a4e004216a7e6fa4f7183ce2e
  const checklist = {
    description: !!profileData.description && !!profileData.type,
    location:
      !!profileData.address1 &&
      !!profileData.postcode &&
      !!profileData.city &&
      !!profileData.county,
    avatarImage: !!profileData.avatar_image,
    focusAreas: !!profileData.categories,
    socials:
      !!profileData.facebook_url ||
      !!profileData.twitter_url ||
      !!profileData.instagram_url ||
      !!profileData.linkedin_url ||
      !!profileData.website_url,
  };

  return (
    <div>
      {Object.entries(checklist).map(([item, value], index) => (
        <div key={index}>
          <div className={classnames(styles.item, value && styles.completed)}>
            {value ? <RiCheckboxCircleFill /> : <RiCircleFill />}
            {t(`profile_checklist.${item}`)}
          </div>
        </div>
      ))}
    </div>
  );
};
